import './free_text_user_profile_attribute_view.js.coffee'

class Customer.EmailUserProfileAttributeView extends Customer.FreeTextUserProfileAttributeView
  inputType: 'email'

  modifyAnything: (event) ->
    @validateValueInput(event)
    super(event)

  validateValueInput: (event) ->
    return unless event
    valid = event.target.checkValidity()
    if valid then @processValidInput(event.target) else @processInvalidInput(event)

  processValidInput: (element) ->
    @clearErrorMessages(element)
    @trigger 'profile_custom_attributes:enable_save'

  processInvalidInput: (event) ->
    errors = @getErrorMessages(event)
    @_renderErrorMessages(event.target, errors)
    @trigger 'profile_custom_attributes:disable_save'

  _renderErrorMessages: (element, errors) =>
    $(element).closest('.definition').find('.errors').html(
      errors.map(@_errorTemplate)
    )

  clearErrorMessages: (element) ->
    @_renderErrorMessages(element, [])

  getErrorMessages: (_event) ->
    [@_invalidEmailMessage()]

  _invalidEmailMessage: ->
    I18n.t('monitoring.conversation_attributes.errors.email.invalid')
